import { Controller } from "@hotwired/stimulus"
import { setCookie } from "../utils/cookies"

// Connects to data-controller="cookie-banner"
export default class extends Controller {
  confirm() {
    document.getElementById('cookie-banner').classList.add('hidden')
    setCookie('cookie_banner_confirmed', '1', 5000)
  }
}
